import axios from "axios";
const KEY = "AIzaSyDwHEonfka0JgfODg2syL1wW935huEnv0k"  // Youtube Data API Key

export default axios.create({
    baseURL:  "https://www.googleapis.com/youtube/v3",
    params:{
        part: 'snippet',
        key: KEY,
        maxResults: 5,
        type: 'video'
    }
})